import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesGrid from './components/FeaturesGrid';
import StepGuideSection from './components/StepGuideSection';
import DemographicsGrid from './components/DemographicsGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="Start Your Business in El Paso Texas - Complete Guide & Resources"
        description="Your complete resource for starting and growing a business in El Paso, Texas. Access business registration guides, local permits, funding opportunities, demographics, and networking resources for El Paso entrepreneurs."
        canonical="/"
        keywords="start business El Paso, El Paso business resources, Texas business registration, El Paso entrepreneurs, business guide El Paso"
        ogImage="https://public.readdy.ai/ai/img_res/7f75621e5fca0acfb8ab4188110a603a.jpg"
      />
      
      {/* LocalBusiness Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "ElPasoTexasBusiness.com",
          "description": "Complete resource for starting and growing businesses in El Paso, Texas",
          "url": "https://elpasotexasbusiness.com",
          "logo": "https://elpasotexasbusiness.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "El Paso",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "31.7619",
            "longitude": "-106.4850"
          },
          "areaServed": {
            "@type": "City",
            "name": "El Paso",
            "containedIn": {
              "@type": "State",
              "name": "Texas"
            }
          }
        })}
      </script>

      {/* Organization Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "ElPasoTexasBusiness.com",
          "url": "https://elpasotexasbusiness.com",
          "logo": "https://elpasotexasbusiness.com/logo.png",
          "description": "Your trusted resource for El Paso business information, registration guides, and entrepreneurial resources",
          "sameAs": [
            "https://www.facebook.com/elpasotexasbusiness",
            "https://twitter.com/elpasotxbiz",
            "https://www.linkedin.com/company/elpasotexasbusiness"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "areaServed": "US",
            "availableLanguage": ["English", "Spanish"]
          }
        })}
      </script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesGrid />
          <StepGuideSection />
          <DemographicsGrid />
          <TestimonialSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}